import moment from 'moment-timezone';
import ExcelJS from 'exceljs';

export const commonMethods = () => {

  const isValidDate = (date) => {
      return date !== "Invalid Date" && date !== null;
  }

  const formatDate = (date) => {
    if (isValidDate(date)) {
      let dateParts = date.split(/[/, ]/);
      let hourMinutesParts = dateParts[4].split(":");
      let day = parseInt(dateParts[0], 10);
      let month = parseInt(dateParts[1], 10) - 1; // Month is zero-based in JavaScript
      let year = parseInt(dateParts[2], 10);
      let hour = parseInt(hourMinutesParts[0], 10);
      let minutes = parseInt(hourMinutesParts[1], 10);

      return new Date(year, month, day, hour, minutes);
      }
  }

  const formatBoolean = (boolean) => {
      return boolean ? "Sí" : "No";
  }

  const formatUtcDateToLocal = (date) => {
      const utcDate = moment.utc(date);
      const timeZone = moment.tz.guess();
      const localDate = utcDate.tz(timeZone);
      const localDateTimeString = localDate.format('YYYY-MM-DD HH:mm');

      return localDateTimeString
  }

  const exportToExcel = async (data, filename, headers = null) => {
    try {
      if (!data || data.length === 0) {
        throw new Error('No hay datos para exportar');
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Datos');

      // Use provided headers, or fall back to keys from the first row
      const columnHeaders = headers || Object.keys(data[0]);
      
      // Add header row
      worksheet.addRow(columnHeaders);
      
      // Style the header row
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE0E0E0' }
      };

      // Add data rows
      data.forEach(item => {
        const row = columnHeaders.map(header => {
          const value = item[header];
          // Handle boolean values
          if (typeof value === 'boolean') {
            return value ? 'Sí' : 'No';
          }
          // Handle null/undefined values
          if (value === null || value === undefined) {
            return '';
          }
          return value;
        });
        worksheet.addRow(row);
      });

      // Auto-fit columns
      worksheet.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, cell => {
          const cellLength = cell.value ? cell.value.toString().length : 10;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        column.width = Math.min(maxLength + 2, 50);
      });

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      
      // Create blob and download
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      throw error;
    }
  }

  return {
    isValidDate,
    formatDate,
    formatBoolean,
    formatUtcDateToLocal,
    exportToExcel
  }
}

export default commonMethods()